module.exports = __webpack_public_path__ + "0b23ca2bde81dbd784adeeb99c8e8cf0.png";